import { render, staticRenderFns } from "./ManufacturerItem.vue?vue&type=template&id=78f511a0&scoped=true&"
import script from "./ManufacturerItem.vue?vue&type=script&lang=js&"
export * from "./ManufacturerItem.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerItem.vue?vue&type=style&index=0&id=78f511a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f511a0",
  null
  
)

export default component.exports